import { Injectable, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class DeviceDetectorService {
	private breakpointObserver = inject(BreakpointObserver);

	// Define what "isDesktop" means for your app using CSS media queries
	// Common breakpoints are available in Breakpoints enum
	readonly isDesktop$: Observable<boolean> = this.breakpointObserver
		.observe([
			Breakpoints.Web,
			Breakpoints.WebLandscape,
			Breakpoints.WebPortrait,
			Breakpoints.Medium,
			Breakpoints.Tablet,
			Breakpoints.Small,
		])
		.pipe(
			map(result => result.matches),
			shareReplay(1) // Share the result and replay the last one for new subscribers
		);

	readonly isMobile$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet]).pipe(
		map(result => result.matches),
		shareReplay(1)
	);
}
